// extracted by mini-css-extract-plugin
export default {"header":"CreateDesign_header__coCy-"};